import React, { useEffect, useRef, useState } from "react";
import DashboardTopSearch from "../../../components/DashboardTopSearch/DashboardTopSearch";
import { useNavigate } from "react-router-dom";
import courseThumbnail from "../../../assets/images/course-img-3.jpg";
// import ProgressBar from "../../../components/ProgressBar/ProgressBar";
// import CourseDetailChapterList from "../../../components/CourseDetailChapterList/CourseDetailChapterList";
import IntroductionToTheCourse from "../../../components/IntroductionToTheCourse/IntroductionToTheCourse";
import { getCourseByIdForAdminCourse } from "../../../redux/features/courseSlice";
import { useSelector, useDispatch } from "react-redux";
import { useSearchParams } from "react-router-dom";
import { Image } from "react-bootstrap";
import { studentCourseCommentAndReviewAPI } from "../../../redux/features/courseSlice";
import { toast } from "react-hot-toast";
import createrImg from "../../../assets/images/Profile-thumbnail-small.svg";
import Notification from "../../../components/Notification/Notification";
import { studentGradeAPI } from "../../../redux/features/courseSlice";
import CourseDetailChapterListForAdmin from "../../../components/CourseDetailChapterListForAdmin/CourseDetailChapterListForAdmin";

const StudentEnrolledCourseForAdmin = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const auth = useSelector((state) => state.auth);

  const [showFeedback, setShowFeedback] = useState(false);
  const [rating, setRating] = useState(0);
  const [searchParams] = useSearchParams();
  const [courseDetail, setCourseDetail] = useState();
  const [curriculumDataList, setCurriculumDataList] = useState({});
  const [comment, setComment] = useState("");
  const [reviewToggle, setReviewToggle] = useState(false);
  const [studentGrade, setStudentGrade] = useState();
  const [isLoading, setIsLoading] = useState(false);
  const feedbackRef = useRef(null);

  const goBack = () => {
    navigate(-1);
  };

  const handleFeedbackClick = () => {
    if (showFeedback) {
      setShowFeedback(false);
    } else {
      setShowFeedback(true);

      setTimeout(() => {
        feedbackRef.current?.scrollIntoView({ behavior: "smooth" });
      }, 100);
    }
  };
  const submitGradeHandle = async () => {
    const res = await dispatch(
      studentCourseCommentAndReviewAPI({
        token: auth.token,
        course_id: searchParams.get("id"),
        comment: comment,
        rating: rating,
      })
    ).unwrap();
    if (res.success) {
      toast.success(res?.message, {
        position: "top-center",
      });
      setShowFeedback(false);
      setRating(0);
    }
  };
  const handleBackToGrading = async () => {
    setShowFeedback(false);
    setRating(0);
  };

  const handleStarClick = (starIndex) => {
    setRating(starIndex + 1); // Set rating based on star clicked (1 to 5)
  };

  const getStudentCourseFetch = async () => {
    const res = await dispatch(
      getCourseByIdForAdminCourse({
        token: auth.token,
        courseId: searchParams.get("id"),
      })
    ).unwrap();
    if (res.success) {
      setCourseDetail(res.data);
    }
  };

  const getStudentGrade = async () => {
    const res = await dispatch(
      studentGradeAPI({ token: auth.token, course_id: searchParams.get("id") })
    ).unwrap();
    if (res.success) {
      setStudentGrade(res?.data);
    }
  };

  useEffect(() => {
    const fetchData = async () => {
      setIsLoading(true);
      try {
        await Promise.all([getStudentCourseFetch(), getStudentGrade()]);
      } finally {
        setIsLoading(false);
      }
    };
    fetchData();
  }, []);

  return (
    <>
      {isLoading && (
        <div className="loader-container">
          <div className="dottedLoading theme-color"></div>
        </div>
      )}
      <div className="topbar mb-20 mb-lg-36">
        <div className="d-flex align-items-center justify-content-between">
          <h3
            className="ah-heading-04 fw-bold black-800 me-29 mb-0 d-flex align-items-center gap-3 cursor-pointer"
            onClick={goBack}
          >
            <span className="icon-arrow-left"></span> Back
          </h3>
          <div className="search-wrapper d-none d-lg-flex align-items-center gap-3">
            <DashboardTopSearch />
            <Notification />
          </div>
        </div>
      </div>
      <div className="course-progress d-flex mb-20 mb-md-30 mb-md-50">
        <div className="course-left d-flex align-items-center flex-column flex-md-row">
          {courseDetail && courseDetail?.course && (
            <Image
              src={
                process.env.REACT_APP_GALLERY_URL +
                JSON.parse(courseDetail?.course?.image_urls)?.[0]
              }
              alt={"Course Image"}
              className="course-img me-18 mb-14 mb-md-0"
              onError={(e) => {
                e.target.onerror = null;
                e.target.src = courseThumbnail; // Fallback to default image
              }}
            />
          )}
          <h3 className="ad-heading-04 fw-bold mb-0">
            {courseDetail?.course?.title}
          </h3>
        </div>
      </div>
      <div className="main-content d-flex">
        <div className="left-panel">
          <IntroductionToTheCourse
            curriculumDataList={curriculumDataList}
            courseDetail={courseDetail?.course}
            courseObject={courseDetail?.course?.learning_objectives}
          />
          <div>
            {courseDetail?.allUnitsCompleted && !showFeedback && (
              <div className="card-default-style py-10 py-sm-15 py-md-25 px-10 px-sm-20 px-md-30 px-lg-45 mt-30">
                <h3 className="ah-heading-04 fw-bold black-100 mb-21">
                  Grading
                </h3>
                <div
                  className="card-primary py-15 px-24 d-flex flex-column justify-content-between w-100"
                  data-card="tabs"
                >
                  <h3 className="mb-10 ah-heading-05 fw-semibold">
                    Your Grades
                  </h3>
                  <p className="fw-normal ah-text-base mb-10">
                    To pass you need at least 80%. We keep your highest score.
                  </p>
                  <div className="d-flex justify-content-between gap-5">
                    <span className="ah-heading-03 fw-bold theme-color">
                      {studentGrade.percentage}%
                    </span>
                    <span
                      onClick={() => setReviewToggle(!reviewToggle)}
                      className="text-decoration-underline theme-color ah-text-base fw-bold cursor-pointer"
                    >
                      Review Feedback
                    </span>
                  </div>
                  {courseDetail?.userReview.length > 0 ? (
                    ""
                  ) : (
                    <div className="d-flex gap-5">
                      <span
                        className="text-decoration-underline theme-color ah-text-base fw-bold cursor-pointer"
                        onClick={handleFeedbackClick}
                      >
                        Add Feedback
                      </span>
                    </div>
                  )}
                </div>
              </div>
            )}
            {courseDetail?.allUnitsCompleted && showFeedback && (
              <div
                className="card-default-style py-10 py-sm-15 py-md-25 px-10 px-sm-20 px-md-30 px-lg-45 mt-30"
                ref={feedbackRef}
              >
                <h3 className="ah-heading-05 fw-bold black-100 mb-21">
                  Add Feedback
                </h3>
                <div className="">
                  <div className="mb-15">
                    <label className="fw-semibold ah-text-base mb-12 d-block black-100">
                      Rate this course
                    </label>
                    <div className="d-flex gap-2">
                      {[1, 2, 3, 4, 5].map((star) => (
                        <svg
                          key={star}
                          width="24"
                          height="24"
                          viewBox="0 0 24 24"
                          fill={rating >= star ? "#FFD700" : "#D3D3D3"}
                          className="cursor-pointer"
                          onClick={() => handleStarClick(star - 1)}
                        >
                          <path d="M12 17.27L18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z" />
                        </svg>
                      ))}
                    </div>
                  </div>
                  <textarea
                    className="form-control w-100 mb-21"
                    rows="5"
                    placeholder="Enter your feedback here..."
                    onChange={(e) => setComment(e.target.value)}
                  ></textarea>
                  <div className="d-flex justify-content-between gap-3">
                    <button
                      className="btn btn-dark no-shadow bg-opacity-50"
                      onClick={handleBackToGrading}
                    >
                      Back to Grading
                    </button>
                    <button
                      className="btn btn-primary no-shadow"
                      onClick={submitGradeHandle}
                    >
                      Submit
                    </button>
                  </div>
                </div>
              </div>
            )}
          </div>
          {reviewToggle && courseDetail?.userReview.length > 0 && (
            <div className="reviews mt-20">
              <h2 className="ah-heading-04 fw-bold mb-20">Reviews</h2>
              {courseDetail?.userReview.map((review, index) => (
                <div
                  className="card-default-style mb-10 mb-sm-20 mb-md-30 mb-lg-40"
                  key={index}
                >
                  <p className="ah-text-base mb-10 mb-sm-20 mb-md-30 text-black-100-80">
                    {review.comment}
                  </p>
                  <div className="d-flex align-items-top">
                    <img
                      src={review?.user?.profile_picture || createrImg}
                      alt={review?.user?.full_name}
                      className="avatar rounded-circle me-15 object-fit-cover"
                    />
                    <div className="review-content">
                      <h3 className="m-0 ah-text-md fw-bold">
                        {review?.user?.full_name}
                      </h3>
                      <p className="position ah-text-sm text-black-100-80 mb-0">
                        {review?.user?.role || "Instructor"}
                      </p>
                      <p
                        className="stars yellow ah-text-lg mt-5 mb-0"
                        style={{ lineHeight: 1 }}
                      >
                        {["★", "★", "★", "★", "★"]
                          .splice(0, review?.rating)
                          .map((item) => (
                            <>{item}</>
                          ))}
                        {["☆", "☆", "☆", "☆", "☆"]
                          .splice(review?.rating, 5)
                          .map((item) => (
                            <>{item}</>
                          ))}
                      </p>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
        <div className="right-panel">
          <div className="card-default-style">
            <h2 className="ad-heading-05 fw-bold mb-10 mb-sm-20 mb-md-32">
              Chapters
            </h2>
            <CourseDetailChapterListForAdmin
              curriculumDataList={curriculumDataList}
              setCurriculumDataList={setCurriculumDataList}
              chapters={courseDetail && courseDetail?.units}
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default StudentEnrolledCourseForAdmin;
